<template>
  <div class="absolute inset-0 overflow-hidden pointer-events-none">
    <!-- Circuit Pattern -->
    <div class="absolute inset-0 opacity-5">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="circuit-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <path d="M20,0 L20,100 M0,20 L100,20 M80,0 L80,100 M0,80 L100,80 M40,40 L60,60 M60,40 L40,60" 
                  stroke="rgba(59, 130, 246, 0.2)" stroke-width="1" fill="none"/>
            <circle cx="50" cy="50" r="3" fill="rgba(99, 102, 241, 0.1)"/>
            <circle cx="20" cy="20" r="2" fill="rgba(59, 130, 246, 0.1)"/>
            <circle cx="80" cy="80" r="2" fill="rgba(59, 130, 246, 0.1)"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#circuit-pattern)"/>
      </svg>
    </div>
    
    <!-- Floating Elements -->
    <div class="absolute top-1/4 left-10 w-16 h-16 border-2 border-blue-200/30 rounded-lg transform rotate-45 animate-float"></div>
    <div class="absolute top-1/3 right-20 w-12 h-12 border-2 border-indigo-200/30 rounded-full animate-float-slow"></div>
    <div class="absolute bottom-1/4 left-1/3 w-24 h-24 border-2 border-blue-300/20 rounded-xl animate-float-delayed"></div>
    
    <!-- Gradient Orbs -->
    <div class="absolute -top-40 -right-20 w-80 h-80 bg-gradient-to-r from-blue-100/40 to-indigo-100/30 rounded-full blur-3xl mix-blend-multiply"></div>
    <div class="absolute top-60 -left-20 w-72 h-72 bg-gradient-to-r from-blue-100/30 to-cyan-100/20 rounded-full blur-3xl mix-blend-multiply"></div>
    <div class="absolute -bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-indigo-100/20 to-blue-100/20 rounded-full blur-3xl mix-blend-multiply"></div>
  </div>
</template>

<script>
export default {
  name: 'BackgroundPattern'
}
</script>

<style scoped>
@keyframes float {
  0%, 100% { transform: translateY(0) rotate(45deg); }
  50% { transform: translateY(-20px) rotate(45deg); }
}

@keyframes float-slow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@keyframes float-delayed {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-25px); }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-float-slow {
  animation: float-slow 8s ease-in-out infinite;
}

.animate-float-delayed {
  animation: float-delayed 10s ease-in-out infinite;
  animation-delay: 2s;
}

@media (prefers-reduced-motion: reduce) {
  .animate-float,
  .animate-float-slow,
  .animate-float-delayed {
    animation: none !important;
  }
}
</style>
